import { useState, useEffect } from "react";
import axios from "axios";

export default function usePavanData() {
  const [pavanData, setPavanData] = useState(null);

  useEffect(() => {
    const url = `${process.env.REACT_APP_CDN_LINK || "https://resources.swmc.com/"}mastermind/jsons/pavan.json`;
    axios.get(url)
      .then(res => setPavanData(res.data))
      .catch(err => console.error("Error fetching pavan data:", err));
  }, []);

  return pavanData;
}
